import React from 'react';
import styles from '~/features/Influencer/Influencer.module.scss';
import dayjs from 'dayjs';
import { Countdown } from '~/features/Influencer/Countdown';

export function InfluencerHeroDesktop(props: {
  src: string;
  alt: string;
  nextLive: string | null;
  children: React.ReactNode | undefined;
  hasEnded: boolean;
}) {
  return (
    <div
      className={'hidden max-w-screen-lg mx-auto px-4 sm:flex items-start mt-5'}
    >
      <div
        className={styles.influencerHero}
        style={{ backgroundImage: `url(${props.src})` }}
      />

      <div className={'flex-1 pl-5'}>
        <div className={'mb-5'}>
          <h1 className={'text-2xl font-semibold'}>
            Live Sale with {props.alt}
          </h1>

          {props.nextLive && (
            <p className={'text-sm'}>
              {dayjs(props.nextLive).format('dddd, MMMM D, YYYY [at] h:mma z')}
            </p>
          )}

          {!props.hasEnded && props.nextLive && (
            <div className={'mt-5'}>
              <Countdown endTime={props.nextLive} />
            </div>
          )}
        </div>

        {props.children}
      </div>
    </div>
  );
}
